import SetPostAsSeenError from './SetPostAsSeenError';
class InvalidPostId extends SetPostAsSeenError {
    postId;
    constructor(postId, options) {
        super('The id provided doesn\'t have a valid format', options);
        this.postId = postId;
    }
}
export default InvalidPostId;
